import styled, { css } from "styled-components";

import { largeScreen } from "src/shared/constants/screenSizes";

export const Container = styled.div`
  border: 0;
  display: none;
  height: 0;
  opacity: 0;
  overflow: hidden;
  transition: ${({ hasTransitions }) => (hasTransitions ? "0.3s" : "none")};
  user-select: none;
  width: 100%;
  z-index: -100;

  &.active {
    background-color: ${({ backgroundColor }) => backgroundColor};
    opacity: 1;
    z-index: 900;
  }

  ${({ isMobile }) =>
    isMobile
      ? css`
          bottom: -100px;
          display: block;
          left: 0;
          position: fixed;

          &.active {
            bottom: 0;
            height: 90px;
          }

          @media (min-width: ${largeScreen + 1}px) {
            display: none;
          }
        `
      : css`
          @media (min-width: ${largeScreen + 1}px) {
            display: block;
            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
            position: absolute;
            margin-top: -55px;

            &.active {
              margin-top: 0;
              height: 50px;
            }
          }
        `}

  ${({ isAtTopOfScreen, isOnTopOfContent }) =>
    isOnTopOfContent &&
    css`
      box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.1);
      display: block;
      position: fixed;
      top: ${isAtTopOfScreen ? "0" : "50px"};

      @media (min-width: ${largeScreen + 1}px) {
        margin-top: 0;
        position: fixed;
        top: ${isAtTopOfScreen ? "0" : "101px"};
      }

      &.active {
        height: auto;
        z-index: 1100;
      }
    `};
`;
